import { LicenseInfo } from '@mui/x-license';

export const installMuiXLicense = () =>
  LicenseInfo.setLicenseKey(
    '96e1394bf00b8dd6e31670e6842347c4Tz0xMjE4NTYsRT0xNzk0NzAwNzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=',
  );
